import { useEffect } from 'react';
import {
  Video,
  usePlayerFromContext,
  SystemEvents,
} from '@loomhq/createhq/dist/video-player';
import { getLocalStorageKey, setLocalStorageKey } from 'utilities/localStorage';
import { PLAYBACK_RATE } from 'constants/localStorage';
import { getParam } from 'utilities/url';

const DEFAULT_PLAYBACK_RATE = 1.0;

const playbackFromLS = getLocalStoragePlaybackRate();

function useStickyPlaybackRate(video: Video): void {
  const player = usePlayerFromContext();

  useEffect(() => {
    if (!player) {
      return;
    }

    const onReady = () => {
      player.playbackRate = getInitialPlaybackRate();
    };

    const onSpeedChange = () => {
      if (player.isReady()) {
        savePlaybackRate(player.playbackRate);
      }
    };

    player.on([SystemEvents.ready], onReady);
    player.on([SystemEvents.speed], onSpeedChange);

    return () => {
      player.off([SystemEvents.speed], onSpeedChange);
      player.off([SystemEvents.ready], onReady);
    };
  }, [player, video.modelId]);
}

function getInitialPlaybackRate() {
  if (playbackFromLS === 'off') {
    return DEFAULT_PLAYBACK_RATE;
  }

  return playbackFromLS || DEFAULT_PLAYBACK_RATE;
}

function savePlaybackRate(playbackRate: number) {
  const STICKY_PLAYBACK_OFF = 'off';

  if (playbackFromLS === STICKY_PLAYBACK_OFF) {
    return;
  }

  setLocalStorageKey(PLAYBACK_RATE, playbackRate);
}

function getLocalStoragePlaybackRate() {
  const STICKY_PLAYBACK_OFF = 'off';
  const playbackQueryParam = getParam('sticky_playback');

  if (playbackQueryParam === STICKY_PLAYBACK_OFF) {
    setLocalStorageKey(PLAYBACK_RATE, STICKY_PLAYBACK_OFF);

    return STICKY_PLAYBACK_OFF;
  }

  return getLocalStorageKey(PLAYBACK_RATE);
}

export default useStickyPlaybackRate;
